import Translate from 'lang/Translate';
import React, { Fragment } from 'react'

const DefaultError = (props: { errorCode: number }) => {
    return (
        <Fragment>
            <div className="error-content">
                <div className="">
                    <Translate text="Content.default_error_msg" />
                </div>
                <div> <Translate text="Error code" /> : {props.errorCode}</div>
            </div>
        </Fragment>
    );
}

export default DefaultError